<template>
  <FourElement></FourElement>
  <div class="collection-container">
    <Filter></Filter>
    <List></List>
    <SetModal></SetModal>
    <!-- <GetModal></GetModal> -->
  </div>
</template>

<script>
import FourElement from './components/FourElement.vue'
import List from './components/List.vue'
import Filter from './components/Filter.vue'
import SetModal from './components/SetModal.vue'
// import GetModal from './components/GetModal.vue'
import { toRefs, reactive, provide, onMounted } from 'vue'
import useAPI from 'UseApi'
const { common_querySiteInfo_get_ } = useAPI(null, [3426])
import { service_col_page_get } from 'server/modules/4886'
// import { commodity_selfbuild_detail_get } from 'server/modules/9817'
import {
  queryAllLiveRooms,
  updateProductStatus,
  cancelProduct
} from 'server/modules/live'
import { message } from 'ant-design-vue'
export default {
  components: {
    FourElement,
    Filter,
    List,
    SetModal
    // GetModal
  },
  setup() {
    const state = reactive({
      searchParams: {
        terminalId: 1,
        brandId: 1,
        channelId: 1,
        siteId: 1
      },
      pagination: {
        current: 1, //默认的当前页数
        pageSize: 10, //每页显示几条数据
        total: 0,
        onChange: (current, pageSize) => {
          state.pagination.current = current
          state.pagination.pageSize = pageSize
          state.getCollection()
          // if (state.filterData.productGetType === 1) {
          //   state.getSkc()
          // } else if (state.filterData.productGetType === 2) {
          //   state.getCollection()
          // }
        }
      },
      //表格数据
      dataSource: [],
      //直播间数据
      liveRoomSelect: [],
      brands: [],
      channels: [],
      sites: [],
      //列
      columns: [
        {
          title: '序号',
          align: 'center',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: '商品ID',
          dataIndex: 'productId',
          key: 'productId',
          align: 'center'
        },
        {
          title: '商品名称',
          align: 'center',
          dataIndex: 'title',
          key: 'title'
        },
        // {
        //   title: '商品描述',
        //   dataIndex: 'desc',
        //   key: 'desc',
        //   align: 'center'
        // },
        {
          title: '价格',
          dataIndex: 'skcDiscountPrice',
          key: 'skcDiscountPrice',
          align: 'center'
        },
        {
          title: '库存',
          dataIndex: 'stock',
          key: 'stock',
          align: 'center'
        },
        {
          title: '商品图',
          dataIndex: 'imageUrl',
          key: 'imageUrl',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operate',
          align: 'center'
        }
      ],
      //筛选
      filterData: {
        productId: '',
        seoUrl: '',
        liveId: ''
      },
      initList: () => {
        state.getLiveRoomList()
      },

      getLiveRoomList() {
        queryAllLiveRooms()
          .then(e => {
            if (e.success) {
              state.liveRoomSelect = e.data.data
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      //collection数据
      getCollection: async () => {
        let params = {
          ...state.searchParams,
          pageNum: state.pagination.current,
          pageSize: state.pagination.pageSize,
          // collectionId: state.filterData.collectionId,
          seoUrl: state.filterData.seoUrl,
          langCode: 'en-GB',
          currency: 'USD'
        }
        console.log(params)
        const { success, data } = await service_col_page_get(params, state)
        if (success) {
          let list = []
          data.dataDetail.map(item => {
            const { skcs } = item
            const {
              skcCode,
              title,
              appSkcDiscountPrice,
              medias,
              appSkcRetailPrice,
              jumpPath
            } = skcs[0]
            list.push({
              productId: skcCode,
              title: title,
              desc: title,
              skcDiscountPrice: appSkcDiscountPrice
                ? parseFloat(appSkcDiscountPrice)
                : '',
              imageUrl: medias.length ? medias[0].src : '',
              stock: '有',
              jumpUrl: jumpPath,
              skcRetailPrice: appSkcRetailPrice
                ? parseFloat(appSkcRetailPrice)
                : parseFloat(appSkcDiscountPrice),
              jsonData: JSON.stringify(skcs[0]),
              status: skcCode === state.filterData.productId ? 1 : 0
            })
          })
          state.dataSource = list
          state.pagination.total = data.total
        } else {
          state.dataSource = []
          state.pagination.total = 0
        }
      },
      //skc数据
      // getSkc: async () => {
      //   let params = {
      //     ...state.searchParams,
      //     skcCode: state.getProductParam.name,
      //     lang: 'en-GB',
      //     currency: 'USD'
      //   }
      //   const { success, data } = await commodity_selfbuild_detail_get(params)
      //   if (success) {
      //     const list = []
      //     data.commodities.map(item => {
      //       const { title, skcCode, description, medias, jumpPath, skus } = item
      //       const imgArr = medias.filter(img => {
      //         return img.type === 1
      //       })
      //       list.push({
      //         productId: skcCode,
      //         title: title,
      //         desc: description,
      //         skcDiscountPrice: skus[0].discountPrice
      //           ? parseFloat(skus[0].discountPrice)
      //           : '',
      //         imageUrl: imgArr.length ? imgArr[0].src : '',
      //         stock: '有',
      //         jumpUrl: jumpPath,
      //         skcRetailPrice: skus[0].retailPrice
      //           ? parseFloat(skus[0].retailPrice)
      //           : skus[0].discountPrice,
      //         jsonData: JSON.stringify(item)
      //       })
      //     })
      //     state.dataSource = list
      //     state.pagination.total = data.total
      //   } else {
      //     state.dataSource = []
      //     state.pagination.total = 0
      //   }
      // },
      //重置筛选
      resetFilter: () => {
        state.filterData = {
          collectionId: '',
          productId: ''
        }
        state.getLiveRoomList()
        state.dataSource = []
        state.pagination.total = 0
      },
      modalVisible: false,
      setFrom: {},
      setRef: null,
      setProduct: (info, index) => {
        // state.setFrom = {
        //   ...state.setFrom,
        //   ...info
        // }
        // state.setFrom.liveId = ''
        // state.modalVisible = true
        const param = {
          ...info,
          liveId: state.filterData.liveId,
          goodsIdx: index - 1
        }
        updateProductStatus(param)
          .then(e => {
            if (e.success) {
              message.success('设置成功！')
              if (state.filterData.liveId) {
                state.filterData.productId = info.productId
                state.getLiveRoomList()
                state.getCollection()
              }
            }
          })
          .catch(e => {
            message.warning(e.retInfo)
            console.log('err: ', e)
          })
      },
      //取消讲解中
      cancel: () => {
        const param = {
          liveId: state.filterData.liveId
        }
        cancelProduct(param)
          .then(e => {
            if (e.success) {
              message.success('取消成功！')
              if (state.filterData.liveId) {
                state.filterData.productId = ''
                state.getLiveRoomList()
                state.getCollection()
              }
            }
          })
          .catch(e => {
            message.warning(e.retInfo)
            console.log('err: ', e)
          })
      },
      modalCancel: () => {
        state.modalVisible = false
      },
      //设置讲解中
      modalSubmit: async () => {
        updateProductStatus(state.setFrom)
          .then(e => {
            if (e.success) {
              message.success('设置成功！')
              if (state.filterData.collectionId) {
                state.filterData.productId = state.setFrom.productId
                state.getCollection()
              }
            }
          })
          .catch(e => {
            message.warning(e.retInfo)
            console.log('err: ', e)
          })
        state.modalVisible = false
      },
      //商品获取
      modalVisibleType: false,
      getProductRef: null,
      getProductParam: {
        name: ''
      },
      //校验
      getProductRules: {
        name: [
          { required: true, message: '请输入名称！' },
          { max: 50, message: '长度不能超过50!' }
        ]
      },
      //选择直播间
      selectLiveRoom() {
        if (state.filterData.liveId) {
          const value = state.liveRoomSelect.filter(
            item => item.id === state.filterData.liveId
          )
          state.filterData.seoUrl = value[0].leftSeoUrl
          state.filterData.productId = value[0].productId
          state.pagination.current = 1
          state.getCollection()
        } else {
          state.dataSource = []
          state.pagination.total = 0
        }
      },
      openModel: () => {
        if (state.filterData.productGetType !== undefined) {
          state.modalVisibleType = true
        }

        state.getProductParam = {
          name: ''
        }
      },
      modalCancelType: () => {
        state.modalVisibleType = false
      }
      // modalSubmitType: async () => {
      //   state.getProductRef
      //     .validateFields()
      //     .then(() => {
      //       if (state.filterData.productGetType === 1) {
      //         state.getSkc()
      //       } else if (state.filterData.productGetType === 2) {
      //         state.getCollection()
      //       }
      //       state.modalVisibleType = false
      //     })
      //     .catch(e => {
      //       console.log('e: ', e)
      //     })
      // }
    })
    onMounted(() => {
      common_querySiteInfo_get_({
        state
      })
      state.initList()
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
